import { ApolloLink } from '@apollo/client';

export const AUTH_ERROR_EVENT = 'apollo:auth-error';
const AUTH_ERROR_CODE = 401;

// Server returns auth failures as a payload-level OperationError (HTTP 200,
// but data.someQuery.error.code === 401).  Walk the response data and fire
// a window event when one is found — picked up by AuthErrorWatcher to navigate.
const containsAuthError = (value: unknown, depth = 0): boolean => {
  if (depth > 6 || value === null || typeof value !== 'object') return false;
  const obj = value as Record<string, unknown>;

  if (
    obj.__typename === 'OperationError' &&
    (obj as { code?: number | null }).code === AUTH_ERROR_CODE
  ) {
    return true;
  }

  for (const v of Object.values(obj)) {
    if (Array.isArray(v)) {
      for (const item of v) {
        if (containsAuthError(item, depth + 1)) return true;
      }
    } else if (containsAuthError(v, depth + 1)) {
      return true;
    }
  }
  return false;
};

export const authErrorLink = new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    if (response.data && containsAuthError(response.data)) {
      window.dispatchEvent(new CustomEvent(AUTH_ERROR_EVENT));
    }
    return response;
  })
);
